import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Service worker registration. Same SW handles offline caching (fetch
// listener) and Web Push (push listener), so registering once at app boot
// gets us both. Doesn't block render — runs after the SPA hydrates.
//
// Skips registration in dev to avoid the "stale SW caches an old build"
// frustration during hot-reload. Vite gates `import.meta.env.PROD`.
if ("serviceWorker" in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err) => {
        // Non-fatal — push features and offline cache stay off, but the SPA
        // works as a normal SPA. Log so we notice in monitoring later.
        // eslint-disable-next-line no-console
        console.warn("[sw] registration failed:", err);
      });
    });
  } else {
    // DEV: actively unregister any pre-existing SW + nuke its caches.
    // This guards against the localhost-port-collision footgun: once
    // usePushSubscription has registered /sw.js on http://localhost:<port>,
    // ANY other dev project using the same port (e.g. the configurator on
    // :8080) gets hijacked by the cached tippspiel HTML/JS — same origin,
    // same SW. By wiping it on every dev boot we make sure switching
    // projects on the same port "just works" again.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      for (const r of regs) r.unregister();
    });
    if ("caches" in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  }
}
